import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import LoginBackground from "../loginBackground";
import { useDispatch } from "react-redux";
import { performSecureLogout } from "../../../core/utils/logoutUtility";
import { tokenService } from "../../../core/utils/tokenService";
import "../login/employeeLogin.css";

const ResetPasswordSuccess = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const navigation = useNavigate();

  useEffect(() => {
    // Automatically purge session and in-memory tokens on mount without forcing premature redirect (Findings 13 & 14)
    tokenService.clearToken();
    try {
      sessionStorage.clear();
      localStorage.removeItem("user");
      localStorage.removeItem("allowed_permissions");
    } catch {}
  }, []);

  const navigationPath = () => {
    performSecureLogout(dispatch, routes.login);
  };

  return (
    <>
      <div className="hero">
        <div className="sub-hero">
          <div className="img-logo">
            <img src="/assets/img/login/logo.png" alt="logoimage" />
          </div>
          <div className="mt-5">
            <img
              src="/assets/img/icons/success-tick.svg"
              alt="success icon"
              className="img-fluid mb-3"
              style={{ maxWidth: "80px" }}
            />
          </div>
          <p className="text-white fs-3 fw-bold sub-title text-center">
            Success
          </p>
          <p className="text-white text-center mb-4">
            Your new password has been successfully saved
          </p>
          {/* Form */}
          <div className="">
            <form className="form-container">
              <button
                type="button"
                onClick={navigationPath}
                className="submit-btn"
              >
                Back to Sign In
              </button>
              <p className="terms-text">
                By clicking on Back to Sign In, you agree to our Terms of
                service and Privacy Policy
              </p>
            </form>
          </div>
        </div>
        <div className="right-img">
          <div className="ladies-img">
            <img src="/assets/img/login/ladies.png" alt="" />
          </div>
          <div className="metro-img">
            <img src="/assets/img/login/metroo.png" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordSuccess;
